// extracted by mini-css-extract-plugin
module.exports = {"hz-Listing-title-new":"ListingTitle_hz-Listing-title-new__YIv8B"};